import { toursApi } from 'api';

export const orderNewMarketingTour = (tour) => async () => {
  return await toursApi.createMarketingTour(tour);
};
